import React, { FC, useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import { ReactivationForm as CrcForm } from '@dev/ee-modules';

import { useTranslation } from 'react-i18next';
import { CrcFormPayload, CrcDecision } from '@dev/ee-api/ee-api-models';
import { push } from 'redux-first-history';
import { useIntercom } from 'react-use-intercom';

import { ApplicationState as State } from '@/store';
import { UpdateCRCFormParam, SendCrcForm, CrcValidate, GetAccountsNameStart } from '@/store/account/actions';

import { links } from '@/services/dictionaries/links';
import { isIntercomEnabled } from '@/services/Secuirty';
import ReactivationFormProps from './ReactivationFormInterface';

const mapState = (state: State, ownProps: ReactivationFormProps): ReactivationFormProps => ({
    ...ownProps,
    browser: state.browser,
    account: state.account,
});
const dispatchProps = {
    Push: push,
    UpdateCRCFormParam,
    SendCrcForm,
    CrcValidate,
    GetAccountsNameStart,
};

interface DispatchProps {
    Push(url: string): void;
    UpdateCRCFormParam(params: CrcFormPayload): void;
    SendCrcForm(): void;
    CrcValidate(decision: CrcDecision): void;
    GetAccountsNameStart(): void;
}

type Props = ReactivationFormProps & DispatchProps;

const ReactivationForm: FC<Props> = (props: Props): JSX.Element => {
    const { t } = useTranslation();

    const { boot, show } = useIntercom() || {};

    useEffect(() => {
        isIntercomEnabled() && boot();
    }, []);

    const launchIntercom = () => {
        isIntercomEnabled() && show();
    };

    return <CrcForm {...props} t={t} links={links} launchIntercom={launchIntercom} />;
};

export default compose(connect<ReactivationFormProps, DispatchProps>(mapState, dispatchProps))(ReactivationForm);
